import styled, { createGlobalStyle } from 'styled-components';
import { colors, fadeIn, fadeOut, easing } from 'ui/theme';
import { OverlayProps } from './Overlay.types';

export const OverlayScreen = styled.div<OverlayProps & { isActive: boolean }>`
  animation-duration: ${({ transitionDuration }) => transitionDuration}ms;
  animation-fill-mode: forwards;
  animation-name: ${({ isActive }) => (isActive ? fadeIn : fadeOut)};
  animation-timing-function: ${({ isActive }) => (isActive ? easing.entrance : easing.exit)};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  ${({ zIndex }) => typeof zIndex === 'number' && `z-index: ${zIndex};`}
  background: ${({ invisible }) => (invisible ? 'transparent' : colors.backgroundScreen)};
  display: flex;
  align-items: center;
  justify-content: center;
`;

// prevents scroll on body when slide over has overlay
export const OverlayBodyOverrides = createGlobalStyle`
  body {
    position: fixed;
    width: 100%;
    height: 100%;
  }
`;
